import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { prop, propOr } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import { useIntegrationHistory, useShipoxDetail, useShipoxRemove, useShipoxUpdate } from '../../hooks'
import ShipoxIntegrationUpdateForm from '../../components/Shipox/ShipoxIntegrationUpdateForm'
import { ShipoxCreateSerializer } from '../../serializers'

function ShipoxIntegrationUpdateContainer () {
  const { guid, tab } = useParams()

  const messages = useMessages()
  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const integrationDetail = useShipoxDetail(guid)
  const integrationUpdate = useShipoxUpdate(guid)
  const integrationRemove = useShipoxRemove()

  const title = prop('name', integrationDetail.detail)
  const type = propOr('', 'type', integrationDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type, tab: INTEGRATION_TABS.GENERAL })

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const handleSubmit = formValues =>
    integrationUpdate.update(ShipoxCreateSerializer(formValues))
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const isLoading = (
    integrationDetail.isLoading ||
    integrationUpdate.isLoading
  )

  const handleRemove = () =>
    integrationRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      isLoading={integrationDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <ShipoxIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={integrationDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={integrationDetail.detail}
        history={integrationHistory}
      />
    </DashboardLayout>
  )
}

export default ShipoxIntegrationUpdateContainer
